export const timestampToDateConverter = timestamp => {
  const a = new Date(timestamp * 1);
  const year = a.getFullYear();
  const month = a.getMonth() + 1;
  const day = a.getDate();
  const date = `${month}/${day}/${year}`;
  return date;
};
